<template>
  <section class="c-section c-section--services">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card class="p-0">
            <div class="container-fluid p-0">
              <div style="height:400px">
                <div class="w-100 d-flex justify-content-center">
                  <b-skeleton-img no-aspect width="100%" height="300px"></b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="d-flex justify-content-center">
                <b-col cols="4">
                  <b-skeleton-img height="80px"></b-skeleton-img>
                </b-col>
              </div>
            </div>
            <div class="container">
              <b-row>
                <b-col cols="3">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img no-aspect height="500px"></b-skeleton-img>
                </b-col>
              </b-row>

              <b-row >
                <b-col cols="3">
                  <b-skeleton-img no-aspect height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="6">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
              </b-row>
            </div>
          </b-card>
      </template>
      <div v-if="context.post" class="c-banner-top">
        <img :src="context.banner_fondo" alt="" class="c-banner-top__background">
        <div class="c-banner-top__gradient"></div>
        <div class="container position-relative h-100">
          <figure class="c-banner-top__semiluna">
            <img
              src="@/assets/images/semiluna.png"
              alt=""
              class="w-100 of--contain d-none d-md-block"
            >
          </figure>
          <div class="c-banner-top__contain">
            <div data-aos="fade-up">
              <h2 class="white fs-50 w-black mb-0">
                {{context.post.post_title}}
              </h2>
              <div class="d-flex">
                <router-link to="/" class="c-banner-top__link">
                  Inicio
                </router-link>
                <span class="mx-1 white fs-16 w-medium">/</span>
                <p class="white fs-16 w-medium mb-0">
                  {{context.post.post_title}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-services">
        <div class="container">
          <div class="row justify-content-center">
            <div data-aos="fade-up" class="col-11 col-md-9 col-lg-7">
              <h2 class="text-center sec-alt fs-16 w-sbold line-height mb-3">
                {{context.subtitulo}}
              </h2>
              <h2 v-html="titulo" class="c-services__title mb-4">
              </h2>
              <p class="sec-alt fs-16 w-sbold line-height text-center mb-5">
                  {{context.descripcion}}
              </p>
            </div>
          </div>
          <!-- <div v-if="serviceList" class="justify-content-center">
            <div class="position-relative">
              <div id="slider-services" class="c-slider-services swiper h-100">
                  <div class="swiper-wrapper position-relative h-100">
                    <div
                      v-for="(item,i) of serviceList"
                      :key="`item-${i}`"
                      data-aos="fade-up"
                      :data-aos-delay="100 * (i + 1)"
                      class="swiper-slide h-100">
                      <a :href="`/servicio/${item.slug}`"
                          class="h-100 d-flex flex-column c-briefcase--service">
                          <div class="c-briefcase__logo">
                            <img :src="item.thumbnail" alt="" class="c-briefcase__img">
                          </div>
                          <div class="c-briefcase__title-card d-flex">
                            <h2>
                              {{item.title}}
                            </h2>
                          </div>
                        </a>
                    </div>
                  </div>
                  <div class="swiper-pagination mt-4" cursor="pointer"></div>
              </div>
              <button id="slider-services-prev" class="slider-services-prev">
                <Icon icon="ooui:arrow-previous-ltr"/>
              </button>
              <button id="slider-services-next" class="slider-services-next">
                <Icon icon="ooui:arrow-previous-rtl"/>
              </button>
            </div>
          </div> -->
          <div v-if="serviceList" class="row gy-3 justify-content-center">
            <div
              v-for="(item,i) of serviceList"
              :key="`item-${i}`"
              data-aos="fade-up"
              :data-aos-delay="100 * (i + 1)"
              class="col-12 col-6 col-lg-3">
              <a :href="`/servicio/${item.slug}`"
                  class="h-100 d-flex flex-column c-briefcase--service">
                  <div class="c-briefcase__logo">
                    <img :src="item.thumbnail" alt="" class="c-briefcase__img">
                  </div>
                  <div class="c-briefcase__title-card d-flex">
                    <h2>
                      {{item.title}}
                    </h2>
                  </div>
                </a>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>
<script>
// import {
//   Swiper,
//   Navigation,
//   Pagination,
//   Autoplay,
// } from 'swiper';

export default {
  data() {
    return {
      test: null,
      context: {},
      contextLoading: true,
      titulo: '',
      serviceLoading: false,
      serviceList: [],
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'servicios' });
  },
  mounted() {
    this.getServices();
  },
  watch: {
    contextLoading(state) {
      if (!state) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.context.post.content;
        this.titulo = tempDiv.getElementsByTagName('h2')[0].innerHTML;

        // this.initServicesSlider();
      }
    },
  },
  methods: {
    getServices() {
      const request = `${process.env.VUE_APP_API}/pages/data/services`;
      this.serviceLoading = true;
      fetch(request, {
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.serviceList = response.data.services;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.serviceLoading = false;
        });
    },

    // initServicesSlider() {
    //   window.setTimeout(() => {
    //     this.sliderServices = new Swiper('#slider-services', {
    //       modules: [Navigation, Pagination, Autoplay],
    //       speed: 1500,
    //       // loop: true,
    //       autoHeight: true,
    //       spaceBetween: 0,
    //       // autoplay: {
    //       //   delay: 3000,
    //       //   disableOnInteraction: false,
    //       // },

    //       breakpoints: {
    //         320: {
    //           slidesPerView: 1,
    //           spaceBetween: 40,
    //         },
    //         720: {
    //           slidesPerView: 2,
    //           spaceBetween: 25,
    //         },
    //         1024: {
    //           slidesPerView: 4,
    //           spaceBetween: 25,
    //         },
    //       },

    //       pagination: {
    //         el: '#slider-services .swiper-pagination',
    //         type: 'bullets',
    //         clickable: true,
    //       },

    //       navigation: {
    //         prevEl: '#slider-services-prev',
    //         nextEl: '#slider-services-next',
    //       },
    //     });
    //   }, 100);
    // },
  },
};
</script>
